import { useState } from "react";
import { ThreeDotsVertical } from "react-bootstrap-icons";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import FormButton from "../../Components/Buttons/FormButton";
import FormModal from "../../Components/FormTag/FormModal";
import FormSelect from "../../Components/FormTag/FormSelect";
import FormToggle from "../../Components/FormTag/FormToggle";
import InputFiled from "../../Components/FormTag/InputFiled";
import SelectFormTagControl from "../../Components/FormTag/SelectFormTagControl";
import {
  accessorialBillCodeList,
  accessorialCalcTypleList,
  accessorialSeleteTypleList,
} from "../../Data/dropdownDataList";
import { ALPHANUM_REGEX, DECIMAL_NUMBER } from "../../Shared/Helper/Constant";
import { PATTERN_ERR_MSG } from "../../Shared/Helper/ValidationMessage";
import { Accessorial } from "./model/Client.type";

interface ClientAccessorialChargesProps {
  handleNext: () => void;
}

export default function ClientAccessorialCharges(
  props: ClientAccessorialChargesProps
) {
  const navigation = useNavigate();
  const { handleNext } = props;
  const [errMsg, setErrMsg] = useState("");
  const [isShowErr, setShowErr] = useState(false);
  const [hideErrMsgTimeout, setHideErrMsgTimeout] =
    useState<NodeJS.Timeout | null>(null);
  const [clientAccessorialData, setClientAccessorialData] =
    useState<Accessorial>(new Accessorial());
  const [accessorialDataList, setAccessorialDataList] = useState<Accessorial[]>(
    []
  );
  const [selectedOptionValue, setSelectedOptionFunction] = useState(null);
  const {
    handleSubmit,
    register,
    reset,
    getValues,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useForm<Accessorial>({
    defaultValues: clientAccessorialData,
  });
  const [modalShow, setModalShow] = useState(false);
  const watchSelectType = watch("selectType");
  const watchAccBillCode = watch("accBillCode");
  const handelModalButton = () => {
    if (watchAccBillCode === "") {
      setShowErr(true);
      setErrMsg("select bill code");
      const timeout = setTimeout(() => {
        setShowErr(false);
        setErrMsg("");
      }, 2000);

      setHideErrMsgTimeout(timeout);
      setModalShow(false);
    } else {
      setShowErr(false);
      setModalShow(!modalShow);
      setValue("selectType", "");
    }
  };
  const handelColseModal = () => {
    reset(new Accessorial());
    setSelectedOptionFunction(null);
    setModalShow(!modalShow);
  };
  const addAccessorialData: SubmitHandler<Accessorial> = (data) => {
    const newObj: Accessorial = {
      accBillCode: data.accBillCode,
      selectType: data.selectType,
      rate: data.rate,
      arn_receipt: data.arn_receipt,
      order_shipment: data.order_shipment,
      claType: data.claType,
      billMin: data.billMin,
    };
    setAccessorialDataList((acc) => [...acc, newObj]);
    setSelectedOptionFunction(null);
    reset(new Accessorial());
    handelColseModal();
  };
  const handelNextBtn = () => {
    if (accessorialDataList.length === 0) {
      setShowErr(true);
      setErrMsg("select bill code");
      const timeout = setTimeout(() => {
        setShowErr(false);
        setErrMsg("");
      }, 2000);

      setHideErrMsgTimeout(timeout);
      setModalShow(false);
    } else {
      setShowErr(false);
      setModalShow(!modalShow);
      setValue("selectType", "");
      handleNext();
    }
  };
  const footer = (
    <>
      <div className="my-2 bg-white rounded">
        <div className="d-flex flex-row-reverse">
          <FormButton
            className="sph-btn me-4"
            handleClick={handleSubmit(addAccessorialData)}
          >
            Done
          </FormButton>
          <FormButton
            className="sph-btn sph-shift me-4"
            handleClick={handelColseModal}
          >
            Cancel
          </FormButton>
        </div>
      </div>
    </>
  );
  const handelCancel = () => {
    navigation("/account/client/overview/grid-view");
  };
  return (
    <>
      <div className="my-2 bg-white rounded py-4">
        {isShowErr && (
          <div
            className="alert alert-danger text-center position-fixed alert-on-top"
            role="alert"
          >
            {errMsg}
          </div>
        )}

        <div className="d-flex ps-4 justify-content-between">
          <div className="col-4 px-2">
            <label className="fw-medium">Bill Code *</label>
            <div className="mt-1">
              <SelectFormTagControl
                name="accBillCode"
                control={control}
                optionList={accessorialBillCodeList}
                className="form-control p-0"
                placeholder="Enter rate"
                selectedOption={selectedOptionValue}
                setSelectedOption={setSelectedOptionFunction}
              />
              <br></br>
            </div>
          </div>
          <div className="margin-top-28">
           <FormButton
            className="sph-btn me-4"
            handleClick={handelModalButton}
          >
            Add
          </FormButton> 
          </div>
          
        </div>
      </div>
      <FormModal
        show={modalShow}
        handleClose={handelModalButton}
        modalTitle="Define Additional Attributes"
        footer={footer}
        modalSize="lg"
      >
        <div className="my-2 bg-white rounded pt-4">
          <div className="d-flex px-4 justify-content-between">
            <div className="col-6 px-2">
              <label className="fw-medium">Select Type </label>
              <div className="mt-1">
                <FormSelect
                  name="selectType"
                  control={control}
                  optionList={accessorialSeleteTypleList}
                  className="form-control p-0"
                  placeholder="Select"
                />
              </div>
            </div>
            <div className="col-6 px-2">
              <label className="fw-medium">Rate </label>
              <div className="mt-1">
                <InputFiled
                  type="text"
                  register={register}
                  name="rate"
                  errors={errors.rate}
                  pattern={{ type: DECIMAL_NUMBER, message: PATTERN_ERR_MSG }}
                  className="form-control"
                  placeholder="Enter $ price"
                />
              </div>
            </div>
          </div>
          <div className="d-flex px-4 justify-content-between mt-4">
            <div className="col-6 d-flex px-2 pb-1 justify-content-between align-self-end">
              <div>
                <label className="fw-medium">ARN/Receipt</label>
              </div>
              <div className="form-check form-switch sidebar-toggler">
                <div className="d-flex mt-1">
                  <FormToggle
                    defaultChecked={true}
                    register={register}
                    name="arn_receipt"
                  />
                  Yes
                </div>
              </div>
            </div>
            <div className="col-6 d-flex px-2 pb-1 justify-content-between align-self-end">
              <div>
                <label className="fw-medium">Order/Shipment</label>
              </div>
              <div className="form-check form-switch sidebar-toggler">
                <div className="d-flex mt-1">
                  <FormToggle
                    defaultChecked={true}
                    register={register}
                    name="order_shipment"
                  />
                  Yes
                </div>
              </div>
            </div>
          </div>
        </div>

        {watchSelectType && (
          <>
            <div className="border-bottom m-4"></div>
            <div className="my-2 bg-white rounded">
              <div className="d-flex px-4 justify-content-between">
                <div className="col-6 px-2">
                  <label className="fw-medium">Calc Type </label>
                  <div className="mt-1">
                    <FormSelect
                      name="claType"
                      control={control}
                      optionList={accessorialCalcTypleList}
                      className="form-control p-0"
                      placeholder="Select"
                    />
                  </div>
                </div>
                <div className="col-6 px-2">
                  <label className="fw-medium">Bill Minimum </label>
                  <div className="mt-1">
                    <FormSelect
                      name="billMin"
                      control={control}
                      optionList={accessorialCalcTypleList}
                      className="form-control p-0"
                      placeholder="Select"
                    />
                  </div>
                </div>
              </div>
              {/* <div className="border-bottom m-4 pt-3"></div> */}
              {/* <div className="d-flex px-4 justify-content-between mt-4">
                <div className="col-6 px-2">
                  <label>SHP$M SCAC </label>
                  <div className="mt-2">
                    <InputFiled
                      type="text"
                      register={register}
                      name="scac"
                      errors={errors.scac}
                      pattern={{
                        type: ALPHANUM_REGEX,
                        message: PATTERN_ERR_MSG,
                      }}
                      className="form-control"
                      placeholder="Enter SHP$M SCAC"
                    />
                  </div>
                </div>
                <div className="col-6 px-2">
                  <label>Markup .10=10%</label>
                  <div className="mt-2">
                    <InputFiled
                      type="text"
                      register={register}
                      name="markUp"
                      errors={errors.markUp}
                      pattern={{
                        type: DECIMAL_NUMBER,
                        message: PATTERN_ERR_MSG,
                      }}
                      className="form-control"
                      placeholder="Enter %"
                    />
                  </div>
                </div>
              </div> */}
            </div>
          </>
        )}
      </FormModal>
      <div className="d-flex flex-column min-height-43">
        {accessorialDataList.length > 0 && (
          <div className="my-2 bg-white rounded p-4">
            <table className="table transferDetailsTable table-striped sph-table table-non-border">
              <thead>
                <tr className="text-center">
                  <th scope="col">Bill Code</th>
                  <th scope="col">Type</th>
                  <th scope="col">Description</th>
                  <th scope="col">Rate</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              <tbody>
                {accessorialDataList.map((item, index) => (
                  <tr className="text-center" key={index}>
                    <td>{item.accBillCode}</td>
                    <td>{item.selectType}</td>
                    <td></td>
                    <td>
                      {item.rate ? "$" : ""}
                      {item.rate ? item.rate : ""}
                    </td>
                    <td>
                      <span className="w-50 badge text-bg-light border border-2 px-3 border-info-subtle cursor-pointer">
                        Active
                      </span>
                    </td>
                    <td>
                      <span
                        className="cursor-pointer dropdown-toggle action-menu"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <ThreeDotsVertical />
                      </span>
                      <ul className="dropdown-menu action-items">
                        <li className="cursor-pointer ms-3 mb-1">Edit</li>
                        <li className="cursor-pointer ms-3 mb-1">Inactive</li>
                        <li className="cursor-pointer ms-3 mb-1">Delete</li>
                      </ul>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        <div className="my-2 bg-white rounded py-3 cta-div mt-auto">
          <div className="d-flex flex-row-reverse">
            {/* {accessorialDataList.length > 0 && ( */}
            <FormButton className="sph-btn me-4" handleClick={handelNextBtn}>
              Next
            </FormButton>
            {/* )} */}
            <FormButton
              className="sph-btn sph-shift me-4"
              handleClick={handelCancel}
            >
              Cancel
            </FormButton>
          </div>
        </div>
      </div>
    </>
  );
}
